import { DatePeriod, DatePeriodSchema } from "@greeter/date";
import { v7 } from "uuid";
import * as z from "zod";

export const ActivePeriodSchema = z.object({
  id: z.string(),
  period: z.object({
    from: z.string().transform((s) => new Date(s)),
    to: z.string().transform((s) => new Date(s)),
  }),
  productId: z.string(),
});
export type ActivePeriod = z.infer<typeof ActivePeriodSchema>;

export function emptyActivePeriod(): ActivePeriod {
  return {
    id: v7(),
    period: { from: new Date(), to: new Date() },
    productId: "",
  };
}

export const ActivePeriodsSchema = z.array(ActivePeriodSchema);
export type ActivePeriods = z.infer<typeof ActivePeriodsSchema>;
